module.exports = __webpack_public_path__ + "static/img/666ff66745ac64560afd814fbbc17d08.23f51f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/666ff66745ac64560afd814fbbc17d08.jpg
// module id = hclD
// module chunks = 0